import React, { Fragment } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';
import { pick } from 'lodash';

import { CenteredSpinner } from '../components/CenteredSpinner/CenteredSpinner';
import { ContainerHeader } from '../components/Container/ContainerHeader/ContainerHeader';
import { TagForm } from '../components/TagForm/TagForm';
import { useTagEnrichment } from '../hooks/useTagEnrichment';
import {
  createTagEnrichment,
  updateTagEnrichment,
} from '../services/api/enrichments';
import { withFetchStatus } from '../services/notifier';
import { omit } from '../helpers/types';

import type { FC } from 'react';
import type { EnrichmentResponse } from '../types';

export const Tag: FC = () => {
  const navigate = useNavigate();
  const { tagId } = useParams<{ tagId: string }>();
  const {
    data: entity,
    isFetching,
    refetch,
  } = useTagEnrichment(tagId === 'new' ? undefined : tagId);

  async function onSubmit(data: EnrichmentResponse) {
    const isNew = data.id === undefined;

    const blob = pick(data, [
      'categoryId',
      'tagId',
      'isProfile',
      'images',
      'description',
    ]);

    if (isNew) {
      const enrichment = await withFetchStatus(createTagEnrichment, {
        success: 'Enrichment created',
        error: 'Failed to create tag enrichment',
      })(blob);

      navigate(`/tags/${enrichment.tagId}`, { replace: true });
    } else {
      await withFetchStatus(updateTagEnrichment, {
        success: 'Enrichment updated',
        error: 'Failed to update enrichment',
      })(blob.tagId, omit(blob, ['tagId'] as const));
      await refetch();
    }
  }

  return (
    <Fragment>
      <ContainerHeader>
        <Link to="/tags">
          <Button type="button" variant="standard">
            Back to tags
          </Button>
        </Link>
      </ContainerHeader>
      {isFetching ? (
        <CenteredSpinner />
      ) : (
        <TagForm enrichment={entity} onSubmit={onSubmit} />
      )}
    </Fragment>
  );
};
